<script setup lang="ts">
/** "rN + edits · hash · Working since rN · saves as rN+1" (plan §3.1); opens the Revisions dialog. */
import { computed } from 'vue';
import { snap, ui } from '@/app/state';
import { nextRevId } from '@/app/navigation';
import { fmtTime, short } from '@/app/format';

const s = computed(() => snap.value);
const commitLine = computed(() => {
  const rev = s.value.currentRevision;
  if (ui.saveError) return `Not saved: ${ui.saveError}`;
  if (ui.empty) return 'Add a reference to begin';
  if (s.value.isDirty) return rev ? `Working since ${rev.id} · saves as ${nextRevId()}` : `Unsaved · saves as ${nextRevId()}`;
  if (ui.savedAt) return `Saved · ${fmtTime(ui.savedAt)}`;
  return rev ? 'No unsaved edits' : 'Not saved yet';
});
const label = computed(() => `${s.value.currentRevision?.id ?? 'New design'}${s.value.isDirty ? ' plus edits' : ''}. ${commitLine.value}. Manufacturing hash ${short(s.value.build.manufacturingHash)}. Open revision history.`);
</script>

<template>
  <button id="revChip" type="button" class="rev-chip" aria-haspopup="dialog" :aria-label="label" :title="ui.projectId ? `Project file: projects/${ui.projectId}/project.json` : undefined" @click="ui.historyOpen = true">
    <span class="rc-main"><span class="rc-rev">{{ s.currentRevision?.id ?? 'new' }}<em v-if="s.isDirty && !ui.empty"> + edits</em></span><span class="rc-hash mono" title="Manufacturing hash">{{ short(s.build.manufacturingHash) }}</span></span>
    <span class="rc-commit">{{ commitLine }}</span>
  </button>
</template>
